exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/*  OWL CAROUSEL */\n.owl-demo .item {\n    height: 140px;\n    background: #acb7bf;\n    padding: 1rem;\n}\n\n.owl-demo .item * {\n    color: #ffffff;\n}\n\n.owl-demo-img .owl-item img {\n    height: 132px;\n}\n\n.owl-demo-video .item-video {\n    height: 300px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// F:/SVNNew/Web/Phoenix HealthCare/HealthCare_UI/node_modules/css-loader?{"sourceMap":false,"importLoaders":1}!F:/SVNNew/Web/Phoenix HealthCare/HealthCare_UI/node_modules/postcss-loader?{"ident":"postcss"}!F:/SVNNew/Web/Phoenix HealthCare/HealthCare_UI/src/assets/modules/vendors/owl-carousel/owl-carousel.css
// module id = ../../../../css-loader/index.js?{"sourceMap":false,"importLoaders":1}!../../../../postcss-loader/index.js?{"ident":"postcss"}!../../../../../src/assets/modules/vendors/owl-carousel/owl-carousel.css
// module chunks = styles